import { InfoStep } from '../../../../backend-process/backend-process-presentation/backend-process-presentation.component';
import { ProductsSummaryComponent } from '../../products-summary.component';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, OnInit, signal } from '@angular/core';
import { IProduktAuswahlDetails, Sparte, TextNodeType } from '@mwe/models';
import { NewClientStore } from '@mwe/services';
import { getAddressGroupFormatted, getContractStartInfoFromTariffs, isProductCategory } from '@mwe/utils';
import { ProductCategoryEnum } from '@mwe/constants';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AddressComponent,
  BasicCardComponent,
  BasicCardTitleComponent,
  HeadlineComponent,
  HeadlineService,
  InfoboxComponent,
  NextStepsComponent,
  ProductIconComponent,
  ProductsSummaryInvoiceOldComponent,
  ProductSummaryContractInfoComponent,
  TariffCardWaermeComponent,
  TariffSelectionContainerComponent,
  WizardProductCardComponent,
} from '@mwe/ui/components';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { CorrelatedCompanyReferencePipe, FormatPhoneNumberPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-products-summary-redesign-new',
  templateUrl: './products-summary-redesign-new.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HeadlineService],
  imports: [
    AddressComponent,
    HeadlineComponent,
    TariffSelectionContainerComponent,
    BasicCardComponent,
    WizardProductCardComponent,
    BasicCardTitleComponent,
    TranslateDirective,
    InfoboxComponent,
    TariffCardWaermeComponent,
    ProductsSummaryInvoiceOldComponent,
    TranslatePipe,
    FormatPhoneNumberPipe,
    ProductSummaryContractInfoComponent,
    TariffSelectionContainerComponent,
    ProductIconComponent,
    NextStepsComponent,
    CorrelatedCompanyReferencePipe,
  ],
})
export class ProductsSummaryRedesignNewComponent extends ProductsSummaryComponent implements OnInit {
  showFormCardInfo = input<boolean>(true);
  headlineReference = input<TextNodeType>('h2');
  showAdditionalInfo = input<boolean>();
  isSummaryProductsFromWevTitleVisible = input<boolean>(false);
  isSummary = input<boolean>(false);
  infoSteps = input<InfoStep[]>([]);

  selectedProducts = signal<[string, IProduktAuswahlDetails][]>(null);
  startDelivery = signal<string>(null);

  protected readonly Sparte = Sparte;

  headlineService = inject(HeadlineService);
  private readonly newClientStore = inject(NewClientStore);

  readonly tariffContractInfos = computed(() =>
    this.selectedProducts().map(data => ({
      title: data?.[1]?.tarif?.tarifName ?? '',
      startDate: data?.[1]?.bedingungen?.angebotsdatum ?? '',
      commitment: data?.[1]?.tarif?.tarifOptionen?.find(option => option.art === 'Vertragsbindung')?.optionLabel ?? '',
      priceGuaranteeDate: data?.[1]?.bedingungen?.preisbindungsende ?? '',
      contractStartDateDetailedInfo: getContractStartInfoFromTariffs(data?.[1].tarif?.ISUTarifKey, this.selectedTariffs()),
      startDelivery: this.startDelivery(),
    })),
  );
  readonly formattedAddressC = computed(() => getAddressGroupFormatted(this.address(), true));
  override readonly formattedAddress = computed(() => getAddressGroupFormatted(this.address()));
  readonly showBenefitsCard = computed(() => !!this.voucherInfo() && this.stromOrGasProducts()?.length > 0);
  readonly providerChange = computed(() => this.newClientStore.contractDetails()?.providerChange);
  readonly showAdditionalInfoBox = computed(() => {
    if (typeof this.showAdditionalInfo() !== 'undefined') {
      return this.showAdditionalInfo();
    }
    if (!this.stromOrGasProducts()?.length && this.fernwaermeProducts()?.length) {
      return false;
    }
    return this.showMeterReading() || !!this.mgmCode() || this.showFormCardInfo();
  });

  constructor() {
    super();
    effect(() => {
      this.headlineService.setReferenceHeadline(this.headlineReference());
    });
  }

  ngOnInit(): void {
    this.selectedProducts.set(
      (Object.entries(this.newClientStore.productSelection() ?? {}) as unknown as [string, IProduktAuswahlDetails][])
        ?.filter(contents => !!contents?.[1])
        ?.filter(([sparte]) => !isProductCategory(sparte, ProductCategoryEnum.FERNWAERME)),
    );

    this.startDelivery.set(
      this.newClientStore.contractDetails()?.earliestSupplyAsPossible
        ? 'summary.contract.start-delivery-value'
        : this.newClientStore.registrationDate(),
    );
  }
}
